import { useI18n } from 'vue-i18n';
import tarjetaIcon from '@/assets/icons/raw/tarjeta.svg';
import ordenarIcon from '@/assets/icons/raw/ordenar.svg';
import monedasIcon from '@/assets/icons/raw/monedas.svg';
import bizumIcon from '@/assets/img/bizum.png';

export const TIPOS_PASARELAS_PAGO = {
  TPV: 'TPV',
  TRANSFERENCIA_MANUAL: 'TRANSFERENCIA_MANUAL',
  INESPAY: 'INESPAY',
  EFECTIVO: 'EFECTIVO',
};

const CATEGORIAS_PASARELAS_PAGO = {
  tpv: {
    icon: tarjetaIcon,
    i18nKey: 'reserva.pagoTPV',
    i18nKeyMobile: 'reserva.pagoTPVMobile',
  },
  bizum: {
    icon: bizumIcon,
    i18nKey: 'reserva.pagoBizum',
    i18nKeyMobile: 'reserva.pagoBizumMobile',
  },
  transferencia: {
    icon: ordenarIcon,
    i18nKey: 'reserva.pagoTransferencia',
    i18nKeyMobile: 'reserva.pagoTransferenciaMobile',
  },
  efectivo: {
    icon: monedasIcon,
    i18nKey: 'reserva.pagoEfectivo',
    i18nKeyMobile: 'reserva.pagoEfectivoMobile',
  },
};

export function normalizePasarelasPago(pasarelasPago) {
  const { t } = useI18n();
  const listPasarelasPago = [];

  ['tpv', 'bizum', 'transferencia', 'efectivo'].forEach(categoria => {
    const items = pasarelasPago?.[categoria];
    if (!items) return;
    items.forEach(item => {
      listPasarelasPago.push({
        id: item.id,
        titulo: t(CATEGORIAS_PASARELAS_PAGO[categoria].i18nKey),
        tituloMobile: t(CATEGORIAS_PASARELAS_PAGO[categoria].i18nKeyMobile),
        nombre: item.nombre,
        icon: CATEGORIAS_PASARELAS_PAGO[categoria].icon,
        refundEnabled: item.refundEnabled,
        manual: item.manual,
        categoria,
      });
    });
  });

  return listPasarelasPago;
}
